import classNames from 'classnames';
import React, { useState } from 'react';
const Tooltip = ({
  tooltipClassNames,
  tooltipWrapperClassNames,
  textClassNames,
  textContent,
  isEnabled = true,
  children
}) => {
  const [isShowingTooltip, setIsShowingTooltip] = useState(false);
  const toolTipClasses = classNames('absolute', 'max-w-xs', 'rounded-lg', 'bg-black', 'p-3', 'shadow-lg', 'mt-2', `${tooltipClassNames || ''}`);
  const textClasses = classNames('text-sm', 'text-white', 'whitespace-normal', `${textClassNames || ''}`);
  const toolTipWrapperClasses = classNames(`${tooltipWrapperClassNames || ''}`);
  return isEnabled ? /*#__PURE__*/React.createElement("div", {
    className: toolTipWrapperClasses,
    onMouseEnter: () => setIsShowingTooltip(true),
    onMouseLeave: () => setIsShowingTooltip(false)
  }, children, isShowingTooltip && textContent && /*#__PURE__*/React.createElement("div", {
    className: toolTipClasses
  }, /*#__PURE__*/React.createElement("p", {
    className: textClasses
  }, textContent))) : children;
};
export default Tooltip;